module.exports = "<div class=\"login-info\">\n  <span *ngIf=\"user?.picture\"><a (click)=\"toggleShortcut()\">\n\t   <img [src]=\"user.picture\" alt=\"me\"\n          class=\"online\"/><span>{{user.username }}</span> <i class=\"fa fa-angle-down\"></i>\n    </a>\n   </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user/login-info/login-info.component.html
// module id = ./src/app/shared/user/login-info/login-info.component.html
// module chunks = main